import { inject, Injectable, signal } from '@angular/core';
import { IIdentity } from '../interfaces/IIdentity';
import { LocalStorageService } from '../../../../core/services/LocalStorageService';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class IdentityStore {

  public static instance: IdentityStore;

  private readonly _localStorageService = inject(LocalStorageService);

  public readonly identity = signal<IIdentity>(this._localStorageService.getItem('identity'));
  public readonly tmpIdentity = signal<IIdentity>(null);

  public constructor() {
    IdentityStore.instance = this;

    toObservable(
      this.identity
    ).subscribe(identity => {
      identity
        ? this._localStorageService.setItem('identity', identity)
        : this._localStorageService.removeItem('identity');
    });
  }
}
